import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';


@Component({
  selector: 'category-list',
  templateUrl: './category-list.component.html',
  styleUrls: ['./category-list.component.scss'],
})
export class CategoryListComponent {

    @Input() serviceCategories: any[] = [];
  @Input() initialSearchText: string = '';
  @Input() initialSelectedCategory: string = ''; // Name of the initially selected category

  @Output() searchTextChanged = new EventEmitter<string>();
  @Output() categorySelected = new EventEmitter<void>();

  searchText: string = '';
  segmentCategory: string = ''; // Stores the name of the currently active category

  constructor() {}

  ngOnInit() {
    this.searchText = this.initialSearchText;
    this.segmentCategory = this.initialSelectedCategory;
  }

  onSearch() {
    this.searchTextChanged.emit(this.searchText);
  }

  serviceCategoriesChange(category) {
    this.segmentCategory = category.name; // Set the active category by name
    this.categorySelected.emit(category);
  }
}